import React, { useState, useRef, useEffect } from 'react'

function ChatInput({ onSendMessage, isLoading }) {
  const [text, setText] = useState('')
  const textareaRef = useRef(null)

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 150) + 'px'
    }
  }, [text])

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!text.trim() || isLoading) return
    onSendMessage(text.trim())
    setText('')
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSubmit(e)
    }
  }

  return (
    <form onSubmit={handleSubmit} className="border-t border-gray-200 p-3 bg-white">
      <div className="flex items-end gap-2 max-w-3xl mx-auto">
        <textarea
          ref={textareaRef}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Describe a menu change..."
          disabled={isLoading}
          rows={1}
          className="
            flex-1 resize-none
            px-3 py-2 text-sm
            border border-gray-300 rounded-xl
            focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400
            disabled:bg-gray-50 disabled:cursor-not-allowed
            placeholder-gray-400
          "
        />
        <button
          type="submit"
          disabled={!text.trim() || isLoading}
          className="
            p-2 rounded-xl
            bg-gray-900 text-white
            hover:bg-gray-800
            disabled:bg-gray-300 disabled:cursor-not-allowed
            transition-colors
            flex-shrink-0
          "
        >
          {isLoading ? (
            <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24" fill="none">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
            </svg>
          ) : (
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          )}
        </button>
      </div>
    </form>
  )
}

export default ChatInput
